import { appMethod as app } from '@utils/app';

import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './VipCard.less';

export default class VipCard extends OfficialPage {
  state = {
    topNavBarData: {
      isDefault: 0,
      title: '会员卡'
    },
    appId: '',
    receiveCard: -1, // 默认不知道是否有领取
    cardDetail: {
      appName: '',
      logoUrl: '',
      duration: '',
      level: '',
      number: ''
    },
    vipRights: {
      freePostage: 0,
      discount: 0,
      giveCouponStr: '',
      integral: 0
    },
    vipNotice: {
      description: ''
    },
    vipPoints: {
      canUseIntegral: 0,
      totalIntegral: 0,
      consumeNum: 0
    },
    vipContact: {
      appName: '',
      phone: '无'
    },
    activeItem: '',
    vipInfo: {},
    isPaidVip: '0'
  }

  constructor(props) {
    super(props);
    document.title = '会员卡';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    let vipId = options.detail || ''
    let franchiseeId = options.franchisee || ''
    let isPaidVip = options.is_paid_vip || ''
    this.setData({
      vipId: vipId,
      franchiseeId: franchiseeId,
      isPaidVip: isPaidVip
    })
    if (vipId) {
      this.getVipInfo()
    } else {
      this.getHeadquartersVipInfo()
    }
  }

  getVipInfo = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/GetVIPCardInfo',
      data: {
        app_id: that.data.franchiseeId,
        vip_id: that.data.vipId,
        is_paid_vip: that.data.isPaidVip
      },
      success: function(res) {
        let cardBackground = ''
        let vip = res.data[0]
        if (parseInt(vip.background_type) == 0) {
          cardBackground = 'url(' + vip.background + ') 0% 0% / 100% 100%'
        } else {
          cardBackground = vip.background
        }
        let giveCouponStr = ''
        for (let i = 0; i < vip.coupon_list.length; i++) {
          giveCouponStr =
            giveCouponStr +
            '免费赠送' +
            vip.coupon_list[i].num +
            '张' +
            vip.coupon_list[i].name +
            '的优惠券,'
        }
        let giveBirCouponStr = ''
        if (vip.birthday_coupon_list && vip.birthday_coupon_list.length) {
          let birthday_coupon_list = vip.birthday_coupon_list
          for (let i = 0; i < birthday_coupon_list.length; i++) {
            giveBirCouponStr =
              giveBirCouponStr +
              '免费赠送' +
              birthday_coupon_list[i].num +
              '张' +
              birthday_coupon_list[i].name +
              '的优惠券,'
          }
        }
        vip.description = vip.description
          ? vip.description.replace(/<br \/>/g, '\n')
          : vip.description
        that.setData({
          vipInfo: vip,
          receiveCard: 1,
          'cardDetail.appName': vip.app_name,
          'cardDetail.logoUrl': vip.logo,
          'cardDetail.duration': vip.expired_time || '',
          'cardDetail.level': vip.title,
          'cardDetail.cardBackground': cardBackground,
          'cardDetail.number': vip.user_vip_id || '',
          'cardDetail.isShowVipid': vip.is_show_vipid || '',
          'vipRights.discount': vip.discount,
          'vipRights.giveCouponStr': giveCouponStr,
          'vipRights.giveBirCouponStr': giveBirCouponStr,
          'vipRights.integral': vip.integral,
          'vipRights.balance': vip.balance,
          'vipRights.freePostage': vip.is_free_postage,
          'vipNotice.description': vip.description,
          'vipPoints.canUseIntegral': vip.can_use_integral,
          'vipPoints.totalIntegral': vip.total_integral,
          'vipPoints.consumeNum': vip.consume_num,
          'vipContact.appName': vip.app_name,
          'vipContact.phone': vip.phone
        })
      }
    })
  }
  getHeadquartersVipInfo = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/GetVIPInfo',
      data: {
        app_id: that.data.franchiseeId || '',
        is_all: 1
      },
      success: function(res) {
        let cardBackground = ''
        if (parseInt(res.data.background_type) == 0) {
          cardBackground = 'url(' + res.data.background + ') 0% 0% / 100% 100%'
        } else {
          cardBackground = res.data.background
        }
        let giveCouponStr = ''
        let giveBirCouponStr = ''
        if (res.data.is_vip != 0) {
          for (let i = 0; i < res.data.coupon_list.length; i++) {
            giveCouponStr =
              giveCouponStr +
              '免费赠送' +
              res.data.coupon_list[i].num +
              '张' +
              res.data.coupon_list[i].name +
              '的优惠券,'
          }
          if (
            res.data.birthday_coupon_list &&
            res.data.birthday_coupon_list.length
          ) {
            for (let i = 0; i < res.data.birthday_coupon_list.length; i++) {
              giveBirCouponStr =
                giveBirCouponStr +
                '免费赠送' +
                res.data.birthday_coupon_list[i].num +
                '张' +
                res.data.birthday_coupon_list[i].name +
                '的优惠券,'
            }
          }
        }
        res.data.description = res.data.description
          ? res.data.description.replace(/<br \/>/g, '\n')
          : res.data.description
        that.setData({
          vipInfo: res.data,
          receiveCard: res.data.is_vip || 0,
          'cardDetail.appName': res.data.app_name,
          'cardDetail.logoUrl': res.data.logo,
          'cardDetail.duration': res.data.expire,
          'cardDetail.level': res.data.title,
          'cardDetail.cardBackground': cardBackground,
          'cardDetail.number': res.data.user_vip_id || '',
          'cardDetail.isShowVipid': res.data.is_show_vipid || '',
          'vipRights.discount': res.data.discount || '',
          'vipRights.giveCouponStr': giveCouponStr || '',
          'vipRights.giveBirCouponStr': giveBirCouponStr || '',
          'vipRights.integral': res.data.integral || '',
          'vipRights.balance': res.data.balance || '',
          'vipRights.freePostage': res.data.is_free_postage || '',
          'vipNotice.description': res.data.description || '',
          'vipPoints.canUseIntegral': res.data.can_use_integral || '',
          'vipPoints.totalIntegral': res.data.total_integral || '',
          'vipPoints.consumeNum': res.data.consume_num || '',
          'vipContact.appName': res.data.app_name || '',
          'vipContact.phone': res.data.phone || ''
        })
      }
    })
  }
  showItemContent = event => {
    let that = this
    let _item = event.currentTarget.dataset.item
    if (that.data.activeItem == _item) {
      _item = ''
    }
    that.setData({
      activeItem: _item
    })
  }
  getVIPCardForUser = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/GetVIPCardForUser',
      data: {
        parent_app_id: app.getAppId(),
        sub_app_id: that.data.franchiseeId
      },
      success: function(res) {
        app.showModal({
          content: '领取成功!'
        })
        that.setData({
          'vipInfo.is_owner': 1
        })
      },
      complete: function() {}
    })
  }

  render() {
    const {
      cardDetail,
      activeItem,
      vipRights,
      vipNotice,
      vipPoints,
      vipContact,
      vipInfo,
      receiveCard
    } = this.state
    return (
      <div className="official-page vip-card-page">
        <TopNav title="会员卡"/>
        <div className="page" id="vipCard">
          {receiveCard == 1 ? (
            <div className="yes-receive-card">
              <div className="card-wrap">
                <div
                  className="card"
                  style={convertLineStyleData('background: ' + cardDetail.cardBackground)}
                >
                  <img className="logo" src={cardDetail.logoUrl} />
                  <div className="title">{cardDetail.appName}</div>
                  <div className="level">{cardDetail.level}</div>
                  {cardDetail.isShowVipid == 1 && cardDetail.number && (
                    <div className="number">{'No.' + cardDetail.number}</div>
                  )}
                  {cardDetail.duration == -1 ? (
                    <div className="duration">永久有效</div>
                  ) : (
                    <div className="duration">{cardDetail.duration}</div>
                  )}
                </div>
              </div>
              <div className="card-content">
                <div className="card-item">
                  <div
                    className={
                      'item-title ' + (activeItem == 'rights' ? 'active' : '')
                    }
                    onClick={this.showItemContent}
                    data-item="rights"
                  >
                    <span>会员权益</span>
                    <label className="ico-moon icon-downarrow"></label>
                  </div>
                  <div
                    className={
                      'item-body vipCard-rights ' +
                      (activeItem == 'rights' ? 'active' : '')
                    }
                  >
                    <div className="content">
                      {vipRights.discount != 0 && (
                        <React.Fragment>
                          <div className="item">打折</div>
                          <div className="item">
                            所有商品一律<span>{vipRights.discount}</span>折
                          </div>
                        </React.Fragment>
                      )}
                      {vipRights.giveCouponStr != '' && (
                        <React.Fragment>
                          <div className="item">优惠券</div>
                          <div className="item">
                            <span>{vipRights.giveCouponStr}</span>购买商品时抵用
                          </div>
                        </React.Fragment>
                      )}
                      {vipRights.giveBirCouponStr != '' && (
                        <React.Fragment>
                          <div className="item">生日优惠券</div>
                          <div className="item">
                            <span>{vipRights.giveBirCouponStr}</span>
                            购买商品时抵用
                          </div>
                        </React.Fragment>
                      )}
                      {vipRights.integral != 0 && (
                        <React.Fragment>
                          <div className="item">积分</div>
                          <div className="item">
                            注册成功即赠送<span>{vipRights.integral}</span>积分
                          </div>
                        </React.Fragment>
                      )}
                      {vipRights.balance && vipRights.balance != 0 && (
                        <React.Fragment>
                          <div className="item">储值</div>
                          <div className="item">
                            注册成功即赠送<span>{vipRights.balance}</span>储值
                          </div>
                        </React.Fragment>
                      )}
                      {vipRights.freePostage == 1 && (
                        <React.Fragment>
                          <div className="item">包邮</div>
                          <div className="item">所有商品购买后统统包邮</div>
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                </div>
                <div className="card-item">
                  <div
                    className={
                      'item-title ' + (activeItem == 'notice' ? 'active' : '')
                    }
                    onClick={this.showItemContent}
                    data-item="notice"
                  >
                    <span>使用须知</span>
                    <label className="ico-moon icon-downarrow"></label>
                  </div>
                  <div
                    className={
                      'item-body vipCard-notice ' +
                      (activeItem == 'notice' ? 'active' : '')
                    }
                  >
                    <div className="content">
                      <div className="item">权限说明</div>
                      <div className="item">
                        会员权限会随着会员卡等级上升而加强，相应特权请留意会员卡下方的会员权益。
                      </div>
                      <div className="item">积分说明</div>
                      <div className="item">
                        在积分商品中，100积分可以代替1元使用。
                      </div>
                      <div className="item">补充说明</div>
                      <div className="item">
                        <span>{vipNotice.description}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-item">
                  <div
                    className={
                      'item-title ' + (activeItem == 'points' ? 'active' : '')
                    }
                    onClick={this.showItemContent}
                    data-item="points"
                  >
                    <span>个人积分</span>
                    <label className="ico-moon icon-downarrow"></label>
                  </div>
                  <div
                    className={
                      'item-body vipCard-points ' +
                      (activeItem == 'points' ? 'active' : '')
                    }
                  >
                    <div className="content">
                      <div className="item">现有积分</div>
                      <div className="item">{vipPoints.canUseIntegral}</div>
                      <div className="item">总积分</div>
                      <div className="item">{vipPoints.totalIntegral}</div>
                      {!!+vipPoints.consumeNum && vipPoints.consumeNum != 0 && (
                        <React.Fragment>
                          <div className="item">积累规则</div>
                          <div className="item">
                            {'消费' + vipPoints.consumeNum + '元，获得1积分'}
                          </div>
                        </React.Fragment>
                      )}
                      <div className="item">使用规则</div>
                      <div className="item">100积分 = 1元</div>
                      <div className="item">提醒</div>
                      <div className="item">
                        消费积分并不会影响升级会员卡，与会员卡升级相关的是总积分
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-item">
                  <div
                    className={
                      'item-title ' + (activeItem == 'contact' ? 'active' : '')
                    }
                    onClick={this.showItemContent}
                    data-item="contact"
                  >
                    <span>联系我们</span>
                    <label className="ico-moon icon-downarrow"></label>
                  </div>
                  <div
                    className={
                      'item-body vipCard-contact ' +
                      (activeItem == 'contact' ? 'active' : '')
                    }
                  >
                    <div className="content">
                      <div className="item">店铺名称</div>
                      <div className="item">{vipContact.appName}</div>
                      <div className="item">联系电话</div>
                      <div className="item">{vipContact.phone}</div>
                    </div>
                  </div>
                </div>
              </div>
              {vipInfo.is_owner != 1 && (
                <div className="receive-btn" onClick={this.getVIPCardForUser}>
                  领取会员卡
                </div>
              )}
            </div>
            ) : (
            receiveCard == 0 && (
            <div className="no-receive-card">
              <div className="tip-area">
                <img
                  className="tip-img"
                  src="http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/no-vip.png"
                />
                <span className="tip-text-1">暂无可用会员卡</span>
                <span className="tip-text-2">获取方式，可留意店家消息</span>
              </div>
            </div>
            )
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/vip-card/VipCard.jsx